import styled from 'styled-components';
import { Tag } from 'library/components/text-elements';
import PlusSvg from 'library/icons/plus.svg';

const RemoveSvg = styled(PlusSvg)`
  transform: rotate(45deg);
  cursor: pointer;
`;

const StyledTagsForm = styled.div`
  display: flex;
  justify-content: space-around;

  select {
    flex: 1;
    max-height: 50px;
    max-width: 200px;
    margin: 1em;
  }
`;

const StyledOutcomeTags = styled.div`
  display: flex;
  flex-direction: column;
  > * {
    margin-bottom: 0.5em;
  }
`;

const StyledTagRow = styled.div`
  display: flex;
  justify-content: space-around;
`;

const OutcomesTag = styled(Tag)`
  color: #1e4c47;
  background: #dbf2ef;
`;

export {
  RemoveSvg,
  StyledTagsForm,
  StyledOutcomeTags,
  StyledTagRow,
  OutcomesTag,
};
